import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationHeader from "./application-header.vue";
import ApplicationCalculations from "./application-calculations/application-calculations.vue";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { LOAD_APPLICATION_DATA, LOAD_MUTED_AUTOMATIONS, LOAD_CLIENT_DATA, SAVE_CLIENT_USERNAME, LOAD_CALCULATED_VALUES, MARK_APPLICATION_AS_READ, LOAD_FILOGIX_SUBMISSIONS, LOAD_APPLICATION_SYNC_STATUS } from "../store/application-actions";
import { LOAD_SUBMISSION_HISTORY } from "../store/lender-submit-actions";
import { LOAD_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { SET_APPLICATION_SYNC_STATUS, SET_ERD_SYNC_INTERVAL_ID, SET_ERD_SYNC_LOADING, SET_ERD_SYNC_PREVIOUS_LOAD_STATUS } from "../store/application-mutations";
import { APPLICATION_SYNC_STATUS, ARE_FILOGIX_DETAILS_VERIFIED, CURRENT_APPLICATION, IS_APPLICATION_SYNCABLE, CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES } from "../store/application-getters";
import ApplicationTabs from "./application-tabs.vue";
import ApplicationNotificationArea from "./application-notification-area.vue";
import { debounce, isEqual } from "lodash";
import WidgetEventsMixin from "@Shared/utils/application-mixins/widget-events-mixin";
import ApplicationPageContainerLoader from "./application-page-container-loader.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { postMainApi } from "@Shared/@Utils/ajax";
import { GET_REFERRAL_API_PARTNERS } from "@Broker/@Modules/main/store/account/account-getters";
export default defineComponent({
  name: "ApplicationPageContainer",
  components: {
    ApplicationHeader,
    ApplicationCalculations,
    ApplicationTabs,
    ApplicationNotificationArea,
    ApplicationPageContainerLoader
  },
  mixins: [WidgetEventsMixin],
  props: {
    clientProfileId: {
      type: [String, Number],
      default: null
    },
    applicationId: {
      type: [String, Number],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    backPath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: true,
      alreadyFetched: false,
      directToLenderTab: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", {
    clientDetails(state) {
      return state.clients[this.clientUsername] || {};
    },
    showDirectToLender(state) {
      return state.schema.showDirectToLender;
    },
    loadSyncStatus(state) {
      return state.filogix.updatingSyncStatus.byApplication[this.applicationId] || {};
    }
  })), mapGetters("ApplicationStore", [CURRENT_APPLICATION, ARE_FILOGIX_DETAILS_VERIFIED, IS_APPLICATION_SYNCABLE, APPLICATION_SYNC_STATUS, CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES])), {}, {
    syncStatus() {
      return this.APPLICATION_SYNC_STATUS(this.applicationId);
    }
  }, mapGetters("AccountStore", [GET_REFERRAL_API_PARTNERS])), {}, {
    hasReferralPartners() {
      const referralApiPartners = this.GET_REFERRAL_API_PARTNERS;
      return !isEmpty(referralApiPartners);
    },
    pages() {
      const pages = [];
      pages.push("application", "documents", "filogix");
      if (this.showDirectToLender) {
        pages.push("direct-to-lender", "forms", "internal-notes");
      }
      pages.push("services");
      return pages;
    },
    headerData() {
      return _objectSpread(_objectSpread({}, this.clientDetails), {}, {
        clientUsername: this.clientUsername,
        agentUsername: this.agentUsername,
        applicationId: this.applicationId
      });
    },
    areFilogixDetailsVerified() {
      return this.ARE_FILOGIX_DETAILS_VERIFIED({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
    },
    loadingApplicationHeader() {
      return !this.alreadyFetched && this.loading;
    },
    currentPage() {
      return this.$route.name.replace("application-", "");
    }
  }),
  watch: {
    $route(current, old) {
      // only reload data if the params change (not the Query or anything else)
      if (current.name === "application" || !isEqual(current.params, old.params)) {
        this.loadApplicationData();
      }
    },
    "CURRENT_APPLICATION.read": {
      handler(read) {
        if (read === false) {
          this.MARK_APPLICATION_AS_READ({
            clientUsername: this.clientUsername,
            agentUsername: this.agentUsername
          });
        }
      },
      immediate: true
    },
    loading(val) {
      if (!val && this.syncStatus.syncing) {
        this.updateSyncStatus({
          startImmediately: false
        });
      }
    }
  },
  beforeMount() {
    // Log access to the application, see MORDEV-6126
    // The lack await is on purpose
    void postMainApi({}, `/client/${this.clientUsername}/application/${this.applicationId}/history/access`);
  },
  mounted() {
    this.loadApplicationData();
    window.addEventListener("beforeunload", this.onBeforeUnload);
    this.$root.$on("update-sync-status", this.updateSyncStatus);
  },
  activated() {
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    this.clearLoadSyncStatus();
    this.$root.$off("update-sync-status");
  },
  deactivated() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    this.clearLoadSyncStatus();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    handlePageChange(page) {
      this.directToLenderTab = page;
    }
  }, mapActions("ApplicationStore", [LOAD_APPLICATION_DATA, LOAD_MUTED_AUTOMATIONS, LOAD_CLIENT_DATA, SAVE_CLIENT_USERNAME, LOAD_CALCULATED_VALUES, MARK_APPLICATION_AS_READ, LOAD_SUBMISSION_HISTORY, LOAD_FILOGIX_SUBMISSIONS, LOAD_APPLICATION_SYNC_STATUS])), mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS])), mapMutations("ApplicationStore", [SET_APPLICATION_SYNC_STATUS, SET_ERD_SYNC_LOADING, SET_ERD_SYNC_INTERVAL_ID, SET_ERD_SYNC_PREVIOUS_LOAD_STATUS])), {}, {
    async loadApplicationData() {
      this.loading = true;
      await this.LOAD_APPLICATION_DATA({
        clientUsername: this.clientUsername,
        agentUsername: this.agentUsername,
        applicationId: this.applicationId,
        clientProfileId: this.clientProfileId
      });
      await _Promise.all([this.LOAD_MUTED_AUTOMATIONS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      }), this.LOAD_CLIENT_DATA({
        clientUsername: this.clientUsername,
        agentUsername: this.agentUsername,
        applicationId: this.applicationId,
        clientProfileId: this.clientProfileId
      }), this.LOAD_SUBMISSION_HISTORY({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      }), this.LOAD_FILOGIX_SUBMISSIONS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      }), this.LOAD_FILOGIX_DETAILS()]);
      this.LOAD_CALCULATED_VALUES({
        clientUsername: this.clientUsername,
        agentUsername: this.agentUsername,
        applicationId: this.applicationId
      });
      if (!this.areFilogixDetailsVerified) this.SET_APPLICATION_SYNC_STATUS({
        applicationId: this.applicationId,
        status: {
          details: {
            isError: true,
            errorType: "AGENT_NOT_VERIFIED"
          }
        }
      });else {
        await this.LOAD_APPLICATION_SYNC_STATUS({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
      }
      this.loading = false;
      this.alreadyFetched = true;
    },
    onBeforeUnload() {
      this.closeWidgetPopover();
    },
    async handleMessage({
      type,
      target,
      data
    }) {
      if (target !== "validation-rules") return;
      if (type === "navigate-validation-rule") {
        const {
          path,
          pathHash
        } = data;
        if (this.$route.name !== "application") {
          await this.$router.push({
            name: "application",
            params: this.$route.params
          });
        }
        this.$root.$emit("navigate-to-field", path, pathHash);
      }
    },
    /**
     * This function helps to avoid the multiple calling of loadApplicationSyncStatusInterval()
     * in a 10 seconds period of time
     * Please, avoid calling this function directly,
     * use updateSyncStatus() instead.
     */
    debounceLoadApplicationSyncStatus() {
      return debounce(this.loadApplicationSyncStatusInterval, 10000); // Wait 10 seconds
    },
    /**
     * Please, avoid calling this function directly,
     * use updateSyncStatus() instead.
     */
    async loadApplicationSyncStatus() {
      this.SET_ERD_SYNC_PREVIOUS_LOAD_STATUS({
        applicationId: this.applicationId,
        previousLoadStatus: this.syncStatus.syncing
      });
      this.SET_ERD_SYNC_LOADING({
        applicationId: this.applicationId,
        loading: true
      });
      await this.LOAD_APPLICATION_SYNC_STATUS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
      if (this.loadSyncStatus.previousLoadStatus && !this.syncStatus.syncing) this.clearLoadSyncStatus();
    },
    /**
     * This function starts the polling of the sync with Expert status
     * and is a wrapper function for loadApplicationSyncStatus().
     * Please, avoid calling this function directly,
     * use updateSyncStatus() instead.
     */
    loadApplicationSyncStatusInterval(startImmediately = false) {
      if (startImmediately) this.loadApplicationSyncStatus();
      this.clearLoadSyncStatusInterval();
      const intervalId = setInterval(async () => {
        if (this._isDestroyed) {
          //If the interval survived for some reason and is still running on a
          //destroyed instance, self-destroy
          clearInterval(intervalId);
          return;
        }
        this.loadApplicationSyncStatus();
      }, 20000); // Every 20 seconds
      this.SET_ERD_SYNC_INTERVAL_ID({
        applicationId: this.applicationId,
        intervalId
      });
    },
    /**
     * This function calls the functions that will start the polling.
     * Since there are some validations in order to avoid
     * the creation of multiples intervals and unnecessary calls,
     * this one is the one that should be called
     * instead of debounceLoadApplicationSyncStatus() or loadApplicationSyncStatusInterval()
     */
    updateSyncStatus({
      startImmediately = false
    }) {
      if (!this.areFilogixDetailsVerified) {
        this.SET_APPLICATION_SYNC_STATUS({
          applicationId: this.applicationId,
          status: {
            details: {
              isError: true,
              errorType: "AGENT_NOT_VERIFIED"
            }
          }
        });
      } else if (!this.loadSyncStatus.loading && this.IS_APPLICATION_SYNCABLE(this.applicationId)) {
        var _this$debounceLoadApp, _this$debounceLoadApp2;
        (_this$debounceLoadApp = (_this$debounceLoadApp2 = this.debounceLoadApplicationSyncStatus).cancel) == null ? void 0 : _this$debounceLoadApp.call(_this$debounceLoadApp2);
        this.clearLoadSyncStatus();
        if (startImmediately) this.loadApplicationSyncStatusInterval(startImmediately);else this.debounceLoadApplicationSyncStatus();
      }
    },
    clearLoadSyncStatus() {
      this.clearLoadSyncStatusInterval();
      this.SET_ERD_SYNC_PREVIOUS_LOAD_STATUS({
        applicationId: this.applicationId,
        previousLoadStatus: null
      });
      this.SET_ERD_SYNC_LOADING({
        applicationId: this.applicationId,
        loading: false
      });
    },
    clearLoadSyncStatusInterval() {
      if (this.loadSyncStatus.intervalId) {
        clearInterval(this.loadSyncStatus.intervalId);
        this.SET_ERD_SYNC_INTERVAL_ID({
          applicationId: this.applicationId,
          intervalId: null
        });
      }
    }
  })
});